import { __assign } from "tslib";
import React, { useContext } from 'react';
import { ComponentContext } from '../../contexts';
import { getFontStyles } from './utils';
export var Text = function (_a) {
    var definition = _a.definition;
    var text = definition.text, color = definition.color, width = definition.width, height = definition.height;
    var PointerArea = useContext(ComponentContext).PointerArea;
    return (React.createElement(React.Fragment, null,
        React.createElement("text", { dominantBaseline: "text-before-edge", style: __assign({ fill: color, userSelect: 'none' }, getFontStyles(definition)) }, text),
        React.createElement(PointerArea, { width: width, height: height })));
};
//# sourceMappingURL=text.js.map